import { render, staticRenderFns } from "./item.vue?vue&type=template&id=6d185d35&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d185d35",
  null
  
)

export default component.exports